import type { Canvas } from "fabric";
import { defineStore } from "pinia";

interface CanvasState {
  canvasWidth: number;
  canvasHeight: number;
  baseCanvasJson: any;
  fabricCanvas: Canvas | null;
  canvasLoader: boolean;
  canvasError: boolean;
  canvasJson: any;
  assets: Record<string, string[]>;
  selectedAssets: Record<string, string | null>;
  canvasForImage: Record<string, any>;
}

export const useCanvasStore = defineStore("canvas", {
  state: (): CanvasState => ({
    canvasWidth: 1140,
    canvasHeight: 718,
    canvasJson: null,
    baseCanvasJson: null,
    fabricCanvas: null,
    canvasLoader: false,
    canvasError: false,
    assets: {},
    selectedAssets: {},
    canvasForImage: {},
  }),
  actions: {
    setCanvasDimensions(width: number, height: number) {
      this.canvasWidth = width;
      this.canvasHeight = height;
    },
    setBaseCanvasJson(json: any) {
      this.baseCanvasJson = json;
      if (json && json.width && json.height) {
        this.canvasWidth = json.width;
        this.canvasHeight = json.height;
      } else {
        this.canvasWidth =
          json?.backgroundImage?.width * (json?.backgroundImage?.scaleX || 1);
        this.canvasHeight =
          json?.backgroundImage?.height * (json?.backgroundImage?.scaleY || 1);
      }
    },
    setCanvasJson(json: any) {
      this.canvasJson = json;
    },
    setCanvasLoader(isLoading: boolean) {
      this.canvasLoader = isLoading;
    },
    setCanvasError(isError: boolean) {
      this.canvasError = isError;
    },
    setFabricCanvas(canvas: any) {
      this.fabricCanvas = canvas;
    },
    setAssets(layerId: string, assets: string[]) {
      this.assets[layerId] = assets;
    },
    setSelectedAsset(layerId: string, asset: string) {
      this.selectedAssets[layerId] = asset;
    },
    setCanvasForImage(key: string, json: any) {
      this.canvasForImage[key] = json;
    },
    reset() {
      this.canvasWidth = 1140;
      this.canvasHeight = 718;
      this.baseCanvasJson = null;
      this.fabricCanvas = null;
      this.canvasLoader = false;
      this.canvasError = false;
      this.canvasJson = null;
      this.assets = {};
      this.selectedAssets = {};
      this.canvasForImage = {};
    },
  },
});
